import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import SiteConfig from '../../assets/site-config.json';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {

  constructor(
      private router: Router,
  ) { }

  ngOnInit() {
      if (SiteConfig.rootRedirectTo.length == 0) {
        this.router.navigate(['/home']);
      } else {
        window.location.href = SiteConfig.rootRedirectTo;
      }
  }

}
